export type Params = Record<string, string | number | undefined>
type ParamPrefix = 'filters' | 'sort';

export const buildParams = (params: Params, prefix: ParamPrefix = 'filters'): string => {
    const builder = new URLSearchParams();

    Object.entries(params).forEach(([id, value], index) => {
        // skip param without value
        if (typeof value === 'undefined') {
            return;
        }

        const idKey = `${prefix}[${index}][id]`;
        builder.append(idKey, id);

        const valueKey = `${prefix}[${index}][value]`;
        builder.append(valueKey, String(value));
    })

    return builder.toString();
}
